import React, { useState, useRef, useCallback } from 'react';
import { useDispatch } from 'react-redux'
import { useMount } from 'react-use';
import { Modal, Spin, message } from 'antd';
import * as orderActions from '@/models/orders/actions'
import styles from './style.module.less';

let map

function BaiduMap(props) {
  const [SDKLoaded] = useState(true);
  const ref = useRef(null);
  const dispatch = useDispatch()

  const confirmLocation = useCallback(() => {
    const { lng, lat } = map.getCenter()
    dispatch(orderActions.confirmLocation({
      id: props.orderId,
      data: { lng, lat }
    }))
  }, [])

  useMount(() => {
    window.map = map = new AMap.Map('baidu')

    if (!props.location || process.env.APP_MODE === 'manager') {
      AMap.service(["AMap.PlaceSearch"], () => {
        //构造地点查询类
        var placeSearch = new AMap.PlaceSearch({
          pageSize: 3, // 单页显示结果条数
          pageIndex: 1, // 页码
          // city: "010", // 兴趣点城市
          // citylimit: true,  //是否强制限制在设置的城市内搜索
          map: map, // 展现结果的地图实例
          panel: "panel", // 结果列表将在此容器中进行展示。
          autoFitView: true // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
        });
        //关键字查询
        placeSearch.search(props.address, function (status, result) {
          if (status == 'error') {
            message.error(`地址查询失败,${result}`);
          }
          // 查询成功时，result即对应匹配的POI信息
        })
      })
    }

    map.plugin(["AMap.ControlBar", "AMap.MapType", "AMap.ToolBar"], () => {
      var type = new AMap.MapType({
        defaultType: 0 //使用2D地图
      });
      map.addControl(type);

      var tool = new AMap.ToolBar({ position: 'LT' });
      map.addControl(tool);
    })

    const lng = props?.location?.lng || 109.846498;
    const lat = props?.location?.lat || 40.661523;
    const marker = new AMap.Marker({
      title: props?.address || '',
      position: new AMap.LngLat(lng, lat),
    });
    map.add(marker);
    map.setZoomAndCenter(15, [lng, lat]);
  });

  return (
    <Spin spinning={!SDKLoaded}>
      <div className={styles.map}>
        <>
          {/* {
            (props.location || process.env.APP_MODE === 'manager' || props.ticketType == 2) && (
              <div className={styles.locationCenter}></div>
            )
          } */}
          {/* {
            !props.readOnly && (process.env.APP_MODE === 'manager' || props.ticketType == 2) && (
              <div className={styles.confirmBtn} onClick={confirmLocation}>确认位置</div>
            )
          } */}
        </>
        <div className={styles.baiduMap} id="baidu" ref={ref}></div>
        <div className={styles.panel} id="panel"></div>
      </div>
    </Spin>
  );
}

export default function MapDialog(props) {
  const [showDialog, toggleDialog] = useState(false);
  const el = React.cloneElement(props.children, {
    onClick: toggleDialog,
  });

  return (
    <React.Fragment>
      {el}
      <Modal
        // title={null}
        title={`地图预览   - ${props.address}`}
        destroyOnClose
        footer={null}
        width={800}
        centered
        visible={!!showDialog}
        onCancel={() => toggleDialog(!showDialog)}>
        <BaiduMap
          location={props.location}
          readOnly={props.readOnly}
          address={props.address}
          orderId={props.orderId}
          ticketType={props.ticketType}
        />
      </Modal>
    </React.Fragment>
  );
}
